/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Button, StyledModal, ModalActions, ButtonGroup } from 'sarsaparilla';

type PropTypes = {
    isOpen?: boolean;
    onClose: () => void;
    onConfirm: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    isLoading?: boolean;
    isDisabled?: boolean;
};

function ConfirmChangesModal({
    isOpen = false,
    onClose,
    onConfirm,
    isLoading,
    isDisabled,
}: PropTypes) {
    return (
        <StyledModal
            size="lg"
            heading="Are you sure you want to make this change?"
            shouldShowCloseButton
            shouldActionsStickInMobile
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick
        >
            <p>
                By confirming your changes and selecting Save Changes on the Order Details
                page, your reservation updates will be immediately processed. If your
                modification requires additional payment, you will be directed to pay
                those fees now. If no additional payment or a refund is required, we will
                get that processed for you and no action is required on your part.
            </p>
            <p>
                Canceling this change will allow you to return to your current
                reservation.
            </p>
            <ModalActions>
                <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                    <Button
                        appearance="tertiary"
                        onClick={onClose}
                        className="rec-button-tertiary"
                    >
                        Cancel Changes
                    </Button>
                    <Button
                        isLoading={isLoading}
                        isDisabled={!!isDisabled}
                        onClick={onConfirm}
                    >
                        Confirm Changes
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}

export default ConfirmChangesModal;
